// Routes — administration plateforme Cecodev (CRM, réglages Inter, marges, supervision).
// Lot 9.5 (2026-10-18) : le pipeline et les axes vivent dans le module
// Programmation de l'org (/o/:slug/programmation), les candidatures, l'annuaire
// des certifications et la vue transverse des projets sont des onglets des
// pages Animateurs et Projets (/o/:slug/…) — anciennes adresses dans
// routes/redirections.ts.
// Lot 7.6 (2026-10-17) : App.tsx éclaté par domaine, enfants de <Routes> recopiés
// tels quels (ordre et commentaires), aucune URL changée ; rendu en fragment dans
// l'ordre d'origine par App.tsx.
import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { LoadingFallback } from "./communs";

export const AdminOrganisationsPage = lazy(() => import("../pages/AdminOrganisationsPage"));
export const QualiopiPage = lazy(() => import("../pages/QualiopiPage"));
export const AdminJournalEnvoisPage = lazy(() => import("../pages/AdminJournalEnvoisPage"));
export const AdminOpcosPage = lazy(() => import("../pages/AdminOpcosPage"));
export const FormationSessionsPage = lazy(() => import("../pages/FormationSessionsPage"));
export const AdminSupervisionPage = lazy(() => import("../pages/AdminSupervisionPage"));
export const CrmAffairesPage = lazy(() => import("../pages/CrmAffairesPage"));
export const PortefeuilleClientsPage = lazy(() => import("../pages/PortefeuilleClientsPage"));
export const AdminAbsencesPage = lazy(() => import("../pages/AdminAbsencesPage"));
export const AdminReferentPage = lazy(() => import("../pages/AdminReferentPage"));
export const AdminOutilsIaPage = lazy(() => import("../pages/AdminOutilsIaPage"));
// PlateformeProduitPage (legacy, dette N20) → redirigée vers /plateforme/formation/:id (cf. App.tsx route + DETTE_NETTOYAGE)
export const AdminPlateformeRedirect = lazy(() => import("../pages/admin-plateforme/AdminPlateformeRedirect"));
export const AdminPlateformeTarifsPage = lazy(() => import("../pages/admin-plateforme/AdminPlateformeTarifsPage"));
export const AdminPlateformeFacturesClientsPage = lazy(() => import("../pages/admin-plateforme/AdminPlateformeFacturesClientsPage"));
export const AdminPlateformeRelancesDebitsPage = lazy(() => import("../pages/admin-plateforme/AdminPlateformeRelancesDebitsPage"));
export const AdminPlateformeDashboardPage = lazy(() => import("../pages/AdminPlateformeDashboardPage"));
export const AdminPlateformeBeneficiairesPage = lazy(() => import("../pages/AdminPlateformeBeneficiairesPage"));
export const AdminPlateformePaiementsPage = lazy(() => import("../pages/AdminPlateformePaiementsPage"));
export const SatisfactionOrgPage = lazy(() => import("../pages/SatisfactionOrgPage"));
export const MargesPage = lazy(() => import("../pages/MargesPage"));
export function routesAdminPlateforme() {
  return (
    <>
{/* Admin pages — SUPER_ADMIN + Cecodev only */}
      {/* CRM Cecodev (chantier CRM C1) — vue plateforme, gate fin par CRM.affaires.view côté serveur */}
      <Route
        path="/plateforme/crm/affaires"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <CrmAffairesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/crm/comptes"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <PortefeuilleClientsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/organisations"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminOrganisationsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* URLs canoniques org-scopées (doctrine URLs, lot résorption 2026-08-06) :
          qualité / satisfaction / reporting vivent sous /organisation/*,
          les anciennes formes /admin/* redirigent (emails historiques). */}
      <Route
        path="/o/:slug/qualite"
        element={
          // Pas d'orgPlateformeOnly (N198) : le Qualiopi est org-scopé
          // (serveur sur req.user.organisationId) et concerne aussi les
          // OF — le gate créait un cul-de-sac pour un pilote OF dont le
          // menu montre l'entrée (même condition que /organisation/
          // satisfaction, qui ne l'a jamais eu).
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <QualiopiPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/satisfaction"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <SatisfactionOrgPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Ancienne forme /admin/plateforme[?tab=…] → routes propres (Phase 2
          refonte navigation, 2026-08-05), cf. AdminPlateformeRedirect. */}
      <Route
        path="/admin/plateforme"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminPlateformeRedirect />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Routes propres des réglages plateforme — trois métiers, trois pages
          (lot 7.6 : AdminPlateformePage éclatée), mêmes chemins. */}
      <Route
        path="/plateforme/tarifs"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminPlateformeTarifsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/factures-clients"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminPlateformeFacturesClientsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/relances-debits"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminPlateformeRelancesDebitsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Marges (FX 2026-08-28) : SEUL écran où la marge apparaît — page
          dédiée discrète, pilote Cecodev uniquement. */}
      <Route
        path="/plateforme/marges"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <MargesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/absences"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminAbsencesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/dashboard"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminPlateformeDashboardPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/beneficiaires"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminPlateformeBeneficiairesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/paiements"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminPlateformePaiementsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/journal-envois"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN"]}>
            <Suspense fallback={<LoadingFallback />}>
              <AdminJournalEnvoisPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/opcos"
        element={
          // orgPlateformeOnly ajouté (N198) : référentiel géré par le
          // pilote plateforme (serveur : requirePiloteCecodev partout) —
          // la route laissait entrer tout PILOTE d'org cliente.
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminOpcosPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Demandes de supervision : PAS d'entrée de menu. La demande se
          dépose sur la fiche produit du catalogue formation ; la file du
          pilote s'ouvre depuis la ligne « supervision » du hub /formation. */}
      <Route
        path="/plateforme/supervision"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminSupervisionPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/formation"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <FormationSessionsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/referent-ia"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminReferentPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/plateforme/outils-ia"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <AdminOutilsIaPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
    </>
  );
}
